import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useContact() {
    const { request } = useAuth(); // this wraps axios with auth headers
    const queryClient = useQueryClient();


    // contact us
    const contactMutation = useMutation({
        mutationFn: (data) => request.post('/contact', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['student'] });
        },
    });


    return {
        // Mutations
        contactMutation: contactMutation.mutateAsync,
        isContacting: contactMutation.isPending,

    };
}
